export const STUDENT_MEETING_ROUTE_NAMES = {
  MY_FEEDBACK: "studentMyFeedback",
  MY_FEEDBACK_DETAIL: "studentMeetingDetail",
  MY_FEEDBACK_TRANSITION_DETAIL: "studentTransitionMeetingDetail",
} as const;
